import {Button, Grid, Paper, TextField, Typography} from "@mui/material";
import * as React from "react";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import {useNavigate, useParams} from "react-router-dom";
import dayjs from "dayjs";
import {ArrowBack} from "@mui/icons-material";
import {useFinesActions} from "../../service/useFinesActions";
import NotAuthorizedDialog from "../../../authentication/component/NotAuthorizedDialog";
import {useHasScope} from "../../../../config/globalConfig";
import {FINES_SCOPE_VIEW} from "../../component/utils/AuthConstants";

const FinesDetail = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'fines'});
    const navigate = useNavigate();
    const {id} = useParams();
    const backToList = "/finessecurity/fines";
    const [finesObject, setFinesObject] = useState<any>(null);
    const {getFinesDetail, viewInvoice} = useFinesActions();
    const hasScope = useHasScope;
    useEffect(() => {
        if (id) {
            getFinesDetail(id).then(res => {
                setFinesObject(res);
            });
        }
    }, []);


    return (
        <>
            <SectionHeader title={t('listHeader.title')}
                           subtitle={t('listHeader.subTitle')}/>
            <Paper elevation={3} sx={{padding: "16px", margin: "18px"}}>
                {hasScope(FINES_SCOPE_VIEW) ?
                    <>
                        <Grid container item spacing={2} alignItems={'center'}>
                            <Grid item xs={12}>
                                <Typography variant={'body2'} color={'primary.light'} fontWeight={700} textTransform={'uppercase'}>
                                    {t("details.reportDetails", {
                                        details: finesObject?.reportNumber,
                                        plate: finesObject?.plate
                                    })}
                                </Typography>
                            </Grid>

                        </Grid>
                        <Grid container columnSpacing={3} rowSpacing={1}>
                            <Grid container item columnSpacing={3} rowSpacing={3}>
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        disabled={true}
                                        id="fineDatetime"
                                        value={finesObject?.fineDatetime ? dayjs(finesObject.fineDatetime).format("L") : ""}
                                        label={t("details.fineDatetime")}
                                        type="text"
                                        InputLabelProps={{shrink: true}}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        disabled={true}
                                        id="plate"
                                        value={finesObject?.plate}
                                        label={t("details.plate")}
                                        type="text"
                                        InputLabelProps={{shrink: true}}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        disabled={true}
                                        id="fineAmount"
                                        value={finesObject?.fineAmount}
                                        label={t("details.fineAmount")}
                                        type="text"
                                        InputLabelProps={{shrink: true}}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        disabled={true}
                                        id="penaltyAmount"
                                        value={finesObject?.penalityAmount}
                                        label={t("details.penaltyAmount")}
                                        type="text"
                                        InputLabelProps={{shrink: true}}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        disabled={true}
                                        id="invoiceDatetime"
                                        value={finesObject?.invoiceDatetime ? dayjs(finesObject.invoiceDatetime).format("L") : ""}
                                        label={t("details.invoiceDatetime")}
                                        type="text"
                                        InputLabelProps={{shrink: true}}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        disabled={true}
                                        id="driverName"
                                        value={finesObject?.driverName}
                                        label={t("details.driverName")}
                                        type="text"
                                        InputLabelProps={{shrink: true}}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        label={t("details.ra")}
                                        value={finesObject?.ra}
                                        fullWidth
                                        disabled={true}
                                        id="ra"
                                        type="text"
                                        InputLabelProps={{shrink: true}}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        disabled={true}
                                        id="entity"
                                        value={finesObject?.entity}
                                        label={t("details.authority")}
                                        type="text"
                                        InputLabelProps={{shrink: true}}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        disabled={true}
                                        id="city"
                                        value={finesObject?.city}
                                        label={t("details.city")}
                                        type="text"
                                        InputLabelProps={{shrink: true}}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        disabled={true}
                                        id="telephone"
                                        value={finesObject?.telephone}
                                        label={t("details.phoneNumber")}
                                        type="text"
                                        InputLabelProps={{shrink: true}}/>
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        disabled={true}
                                        id="email"
                                        value={finesObject?.email}
                                        label={t("details.email")}
                                        type="text"
                                        InputLabelProps={{shrink: true}}/>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                            <Grid container item xs={12} rowSpacing={1} columnSpacing={3}
                                  justifyContent={"flex-end"}>
                                <Grid item>
                                    <Button color={"accent"}
                                            disabled={!finesObject?.invoiceId}
                                            onClick={() => {
                                                viewInvoice(finesObject?.invoiceId).then((res) => {
                                                    if (res?.result) {
                                                        let pdfWindow = window.open("");
                                                        pdfWindow!.document.write(
                                                            `<iframe width='100%' height='100%' src='data:application/pdf;base64,${encodeURI(res.result)}'/>`
                                                        );
                                                    }
                                                });
                                            }}>
                                        {t("buttons.viewInvoice")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                    : <NotAuthorizedDialog/>}
            </Paper>
        </>
    );
}
export default FinesDetail;